import Api from './Api'
import axios from 'axios'
import { getBaseUrl } from 'config'
import {
  ForgetPasswordDataInterface,
  UserLoginInterface,
} from '../../interfaces'
import { errorHandler } from '../../utils'

class Account extends Api {
  loginByMobile = async (mobile: string): Promise<any> => {
    // Test-server login must not inherit the authenticated API instance headers.
    const result = await axios.post(`${getBaseUrl()}/Account/LoginByMobile?mobile=${encodeURIComponent(mobile)}`)
    return result.data
  }

  loginUser = async (data: UserLoginInterface): Promise<any> => {
    const result = await this.postJsonData('/Account/Login', data)
    return result.data
  }

  forgetPassword = async (data: ForgetPasswordDataInterface): Promise<any> => {
    try {
      const result = await this.postJsonData(
        `/Account/ForgetPassword?mobile=${data.mobile}&captchaId=${data.captchaId}&captchaInput=${data.captchaInput}`,
      )
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  requestTicket = async (data: any): Promise<any> => {
    try {
      // CAPTCHA (disabled):
      // `/Account/RequestTicket?mobile=${data.mobile}&captchaId=${data.captchaId}&captchaInput=${data.captchaInput}`
      const result = await this.postJsonData(
        `/Account/RequestTicket?mobile=${data.mobile}`,
      )
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  loginByTicket = async (data: any): Promise<any> => {
    try {
      // CAPTCHA (disabled):
      // `/Account/LoginByTicket?ticketId=${data.ticketId}&ticket=${data.ticket}&captchaId=${data.captchaId}&captchaInput=${data.captchaInput}`
      const result = await this.postJsonData(
        `/Account/LoginByTicket?ticketId=${data.ticketId}&ticket=${data.ticket}`,
      )
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
}

export default Account
